<template>
  <div id="app">
    <a-header :mark="hideFooter"></a-header>
    <router-view></router-view>
    <a-footer></a-footer>
  </div>
</template>

<script>
import AHeader from "@/views/bluebird/pageHeader.vue";
import AFooter from "@/views/bluebird/pageFooter.vue";

export default {
  components: {
    AHeader,
    AFooter,
  },
  data() {
    return {
      bottomFixed: false,
      fixedDefault: false,
      hideFooter: false
    }
  },
  watch: {
    $route() {
      window.scrollTo(0, 0);
      this.judgeBottomFixed();
    },
  },
  created() {
    this.judgeBottomFixed();
  },
  methods: {
    judgeBottomFixed() {
      const isDailyPage = this.$route.path.includes("daily");
      const isContactPage = this.$route.path.includes("contact");
      this.bottomFixed = isDailyPage;
      this.fixedDefault = isContactPage;
      console.log("this.$route.name", this.$route.name);
      this.hideFooter =
        this.$route.name === "privacy" || this.$route.name === "terms";
    }
  }
};
</script>
